(() => {
  'use strict';
  function suggestionValue(current, edited, proposed) { return edited ? current : proposed; }
  if (typeof module !== 'undefined') module.exports = {suggestionValue};
  if (typeof document === 'undefined') return;
  const root=document.querySelector('[data-smagtron-audience-root][data-audience=business]');
  if (!root) return;
  const data=JSON.parse(root.querySelector('[data-audience-examples]').textContent);
  const dialog=root.querySelector('dialog');
  const application=root.querySelector('#sv5-project-idea');
  let edited=false, opener=null;
  application.addEventListener('input',()=>{edited=true;});
  function showExample(button,title,description,image,alt,request){
    opener=button;
    root.querySelector('#sv5-dialog-title').textContent=title;
    root.querySelector('#sv5-dialog-desc').textContent=description;
    const img=root.querySelector('#sv5-dialog-image');
    img.hidden=!image;
    root.querySelector('.smagtronAudience-dialog-body').classList.toggle('smagtronAudience-no-image',!image);
    if(image){img.src=image;img.alt=alt;}
    const requestButton=root.querySelector('#sv5-dialog-request');
    requestButton.hidden=!request;requestButton.dataset.request=request||'';
    dialog.showModal();dialog.querySelector('.smagtronAudience-dialog-close').focus();
  }
  root.querySelectorAll('[data-example]').forEach(button=>button.addEventListener('click',()=>{
    const p=data[button.dataset.example];
    showExample(button,p.title,p.description,p.image,p.alt,p.request);
  }));
  root.querySelectorAll('[data-process]').forEach(button=>button.addEventListener('click',()=>{
    const p=data.processes[button.dataset.process];
    showExample(button,button.dataset.process+' · '+p[0],p[1],p[2],p[3],button.dataset.process+' – '+p[0]);
  }));
  dialog.querySelector('.smagtronAudience-dialog-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{if(document.activeElement===document.body)opener?.focus();});
  dialog.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const list=[...dialog.querySelectorAll('button,a[href]')].filter(el=>!el.hidden&&el.getClientRects().length);
    const first=list[0],last=list.at(-1);
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });
  // Read the request at click time: dialog CTAs receive their context on open.
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-request]');
    if (!button || !root.contains(button)) return;
    event.preventDefault();if(dialog.open)dialog.close();
    application.value=suggestionValue(application.value,edited,button.dataset.request||'');
    history.replaceState(null,'','#sv5-request');
    root.querySelector('#sv5-request').scrollIntoView({block:'start'});
    application.focus({preventScroll:true});
  });
  // Poster-only native range: same 54px thumb travel as the painted handle.
  root.querySelectorAll('#sv5-poster .smagtronAudience-poster-stage').forEach(stage => {
    const range = stage.querySelector('input[data-compare-range]');
    const views = stage.parentElement.querySelectorAll('[data-compare-view]');
    const update = () => {
      const fraction = (Number(range.value) - Number(range.min)) / (Number(range.max) - Number(range.min));
      const split = Number(stage.dataset.start) + fraction * (Number(stage.dataset.end) - Number(stage.dataset.start));
      stage.style.setProperty('--split', split + '%');
      range.setAttribute('aria-valuetext', Math.round(fraction * 100) + ' Prozent Vorher im Plakatvergleich');
      views.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.compareView === 'before' ? fraction === 1 : fraction === 0)));
    };
    range.addEventListener('input', update);
    views.forEach(button => button.addEventListener('click', () => {
      range.value = button.dataset.compareView === 'before' ? range.max : range.min;
      update();
    }));
    update();
  });
})();
